var _defs, _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileyFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Smiley_Face",
    "data-name": "Smiley Face",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".smiley-cls-1{fill:#05b2ae;}.smiley-cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Smiley Face") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "smiley-cls-1",
    cx: 20.5,
    cy: 20.5,
    r: 20.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "smiley-cls-2",
    cx: 12.17,
    cy: 14.73,
    r: 3.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "smiley-cls-2",
    cx: 27.55,
    cy: 14.73,
    r: 3.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "smiley-cls-2",
    d: "M61.07,75.74H82a2.34,2.34,0,0,1,2,3.59c-2.14,3.36-6.17,7.86-12.45,7.86s-10.31-4.5-12.44-7.86A2.34,2.34,0,0,1,61.07,75.74Z",
    transform: "translate(-51.03 -52)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyFace);
export default __webpack_public_path__ + "static/media/Smiley Face.849034c259118effbc3467dfd2ddf00d.svg";
export { ForwardRef as ReactComponent };